module.exports = __webpack_public_path__ + "dacca064189d5a0b53d1718428f428a1.svg";